module.exports = __webpack_public_path__ + "img/D202001_2.b301d676.jpg";